import { FC } from 'react';

import { LabelStyled } from './Label.styled';
import { IChildren } from '../../../../../interfaces/common/common';

export const Label : FC<IChildren> = ({children}) => {
  return (<LabelStyled>{children}</LabelStyled>);
}